import { createContext, useContext } from 'react'
import type { MetaSearchOfferListItem } from 'hooks/Offers/useMetaSearchOfferList'

export const MetaSearchContext = createContext<Array<MetaSearchOfferListItem> | undefined>(undefined)

export const useMetaSearchContext = () => {
  return useContext(MetaSearchContext)
}
